import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { BROWSER_ROUTES } from "@constants/browser.routes";
import { getCopyrightText } from "@components/Footer/utils/getCopyright";
import { getInitialSidebarCollapsed } from "@features/CmDashboard/cmAdmin";
import type { RootState } from "@store/store";
import { useTranslation } from "react-i18next";
import { ENV } from "@config/env";
import "@components/Sidebar/Sidebar.css";

export const Footer: React.FC = () => {
	const { t } = useTranslation();
	const user = useSelector((state: RootState) => state.user.user);
	const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(() => getInitialSidebarCollapsed(user));

	// Listen for sidebar toggle events
	useEffect(() => {
		const handleSidebarToggle = (event: CustomEvent<{ isCollapsed: boolean }>) => {
			setIsSidebarCollapsed(event.detail.isCollapsed);
		};

		window.addEventListener("sidebarToggle", handleSidebarToggle as EventListener);
		return () => {
			window.removeEventListener("sidebarToggle", handleSidebarToggle as EventListener);
		};
	}, []);

	return (
		<footer
			className={`bg-white border-t py-4 px-8 flex items-center justify-between text-sm footer-content ${isSidebarCollapsed ? "footer-collapsed" : "footer-expanded"}`}>
			<div className="text-gray-500">{getCopyrightText(t("psdaCommon.footer.copyright"), t("titleSourceWp"))}{ENV.VERSION && <span className="ml-2 text-gray-400">{ENV.VERSION}</span>}</div>
			<div className="space-x-2">
				<Link to={BROWSER_ROUTES.PRIVACY_POLICY} className="text-primary hover:underline">
					{t("psdaCommon.footer.privacyPolicy")}
				</Link>
				<span className="text-gray-400">|</span>
				<Link to={BROWSER_ROUTES.TERMS_AND_CONDITIONS} className="text-primary hover:underline">
					{t("psdaCommon.footer.termsOfService")}
				</Link>
			</div>
		</footer>
	);
};
